import { render, staticRenderFns } from "./YesModal.vue?vue&type=template&id=47ba5aea&scoped=true&"
import script from "./YesModal.vue?vue&type=script&lang=js&"
export * from "./YesModal.vue?vue&type=script&lang=js&"
import style0 from "./YesModal.vue?vue&type=style&index=0&id=47ba5aea&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "47ba5aea",
  null
  
)

export default component.exports